import {useAuth} from '@common/auth/use-auth';
import {useThemeSelector} from '@ui/themes/theme-selector-context';
import {ButtonBase} from '@ui/buttons/button-base';
import {ArrowDropDownIcon} from '@ui/icons/material/ArrowDropDown';
import {ReactElement} from 'react';
import {ListboxItemProps} from '@ui/forms/listbox/item';
import {NavbarAuthMenu} from '@common/ui/navigation/navbar/navbar-auth-menu';
import {Avatar} from '@ui/avatar/avatar';

export interface NavbarAuthUserProps {
  items?: ReactElement<ListboxItemProps>[];
}
export function NavbarAuthUser({items = []}: NavbarAuthUserProps) {
  const {user} = useAuth();
  const {selectedTheme} = useThemeSelector();
  if (!selectedTheme || !user) return null;

  const mobileButton = (
    <ButtonBase
      className="md:hidden"
      role="presentation"
      aria-label="toggle authentication menu"
    >
      <Avatar
        circle
        size="w-32 h-32"
        src={user.image || undefined}
        label={user.name}
        className="ring-1 ring-inset ring-primary/35"
      />
    </ButtonBase>
  );
  const desktopButton = (
    <ButtonBase
      className="hidden items-center gap-10 rounded-full px-6 py-4 transition-colors hover:bg-chip/70 md:flex"
      role="presentation"
    >
      <Avatar
        circle
        size="w-32 h-32"
        src={user.image || undefined}
        label={user.name}
        className="ring-1 ring-divider"
      />
      <span className="block max-w-132 overflow-hidden overflow-ellipsis whitespace-nowrap text-sm font-medium">
        {user.name}
      </span>
      <ArrowDropDownIcon className="block icon-sm text-muted" />
    </ButtonBase>
  );

  return (
    <NavbarAuthMenu items={items}>
      <span role="button">
        {mobileButton}
        {desktopButton}
      </span>
    </NavbarAuthMenu>
  );
}
